import React from "react";
import Footer from "../Component/Footer/Footer";
import Header from "../Component/Header/Header";
import Profilebanner from "../Pages/Profile/Profile";
import Profiletabbing from "../Pages/Profile/Profiletabbing";
import Latestupdate from "../Component/Latestupdate/Latestupdate";

const Profiletheme = () => {
  return (
    <>
      <Header />
      {/* <Profilebanner /> */}
      <Profiletabbing />
      {/* <Latestupdate /> */}
      <Footer />
    </>
  );
};
export default Profiletheme;
